export default class Interval {
    protected _id: number | undefined;
    protected _timeout: number;
    protected _callback: () => void;

    constructor(timeoutMs: number, callback: () => void) {
        this._id = undefined;
        this._timeout = timeoutMs;
        this._callback = callback;
    }

    public get isRunning(): boolean {
        return this._id !== undefined;
    }

    public start(): void {
        if (!this.isRunning) {
            this._id = window.setInterval(this._callback, this._timeout);
        }
    }

    public stop(): void {
        if (this.isRunning) {
            window.clearInterval(this._id);
            this._id = undefined;
        }
    }
}
